import React, { useEffect, useState } from 'react'
import { Field } from 'redux-form'
import { AutoCompleteSelect } from '../../../../../../../../../../itrust_common/components/form'
import EyeMedFormButton from '../EyeMedFormButton'
import { connect, useDispatch } from 'react-redux'
import { frameOptionsEdit, frameOptionsLoad } from '../../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { change } from 'redux-form'

const FrameOptionFields = [
  {
    fieldName: "frameManufacturer",
    label: "Manufacturer",
    displayName: 'manufacturer_name',
    nextFieldName: "frameBrand",
  },
  {
    fieldName: "frameBrand",
    label: "Brand",
    displayName: 'brand_name',
    nextFieldName: "frameModel",
  },
  {
    fieldName: "frameModel",
    label: "Model",
    displayName: 'model_name',
    nextFieldName: "frameColor",
  },
  {
    fieldName: "frameColor",
    label: "Color",
    displayName: 'color_name',
    nextFieldName: "frameEyeSize",
  },
  {
    fieldName: "frameEyeSize",
    label: "Eye Size",
    displayName: 'eye_size',
    nextFieldName: "frameTempleLength",
  },
  {
    fieldName: "frameTempleLength",
    label: "Temple Length",
    displayName: 'temple_length',
    nextFieldName: "frameSku",
  },
  {
    fieldName: "frameSku",
    label: "SKU",
    displayName: 'sku',
    nextFieldName: "",
  }
]

function FrameStep1(props) {
  const { frameOptions, visionInsuranceClaimForm, frameOptionsLoading } = props
  const dispatch = useDispatch()

  const buildDefaultFilter = (frames) => {
    if (!frames) return { frameManufacturer: '' }
    return FrameOptionFields.reduce((acc, field) => {
      acc[field.fieldName] = frames[field.displayName] ?? ''
      return acc
    }, {})
  }

  const [frameFilter, setFrameFilter] = useState(() => buildDefaultFilter(visionInsuranceClaimForm.frames))

  useEffect(() => {
    handleFramesDataLoad(frameFilter)
    return () => {
      setFrameFilter(buildDefaultFilter(visionInsuranceClaimForm.frames))
    }
  }, [])

  const handleFramesDataLoad = (filter) => {
    const nextFilter = { ...frameFilter, ...filter }
    dispatch(frameOptionsLoad(visionInsuranceClaimForm.id, { selections: nextFilter }))
    setFrameFilter(nextFilter)
  }

  const handleFieldChange = (field, value) => {
    const changedIndex = FrameOptionFields.findIndex(f => f.fieldName === field.fieldName)
    const fieldsToReset = FrameOptionFields.slice(changedIndex + 1)
    fieldsToReset.forEach(f => dispatch(change("EyeMedClaimForm", `frames.${f.displayName}`, '')))
    const resetFields = fieldsToReset.reduce((acc, f) => ({ ...acc, [f.fieldName]: '' }), {})
    const optionsToReset = fieldsToReset.slice(1).reduce((acc, f) => ({ ...acc, [f.fieldName]: [] }), {})
    dispatch(frameOptionsEdit({ ...optionsToReset, frameOptionsLoading: true }))
    handleFramesDataLoad({ [field.fieldName]: value.value, ...resetFields })
  }

  return (
    <div className="position-relative">
      {frameOptionsLoading && <h4 className="text-primary mb-4 text-center position-absolute font-size-40 z-index-2" style={{ top: '16rem', right: '45%' }}>Loading...</h4>}
      {FrameOptionFields.map(field => <Field
        name={field.displayName}
        valueField="value"
        textField="value"
        data={frameOptions[field.fieldName].map(item => ({ value: item }))}
        label={field.label}
        key={`${frameOptions[field.fieldName].length}-${field.fieldName}`}
        hideResetButton={true}
        supportAutoComplete={true}
        displayName={field.displayName}
        wrapperClasses="form-group"
        component={AutoCompleteSelect}
        onChangeHook={(value) => handleFieldChange(field, value)}
        // onChangeHook={(value) => field.nextFieldName && handleFramesDataLoad({ [field.fieldName]: value.value, [field.nextFieldName]: '' })}
        disabled={frameOptions[field.fieldName].length === 0 || frameOptionsLoading}
      />)}
      <EyeMedFormButton currentModule="Frame" disable={frameOptionsLoading} />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsuranceClaimForm } = state
  return {
    frameOptionsLoading: visionInsuranceClaimForm.frameOptions.frameOptionsLoading,
    frameOptions: visionInsuranceClaimForm.frameOptions,
  }
}

export default connect(mapStateToProps)(FrameStep1);